module.exports = __webpack_public_path__ + "static/visibleLabelsYes-bb153983b28939a8b83c8e6a52c973c6.png";